import cx from 'classnames'
import { LogoURLs } from '@commutifi-fe/interfaces'
import { colors } from '../../style/constants'
import { CommutifiLogo } from '../CommutifiLogo'
import './styles.scss'

/**
 * Uses organization custom branding different logos URLs to render the proper logo
 * between a mark (+ Original or white color), a logo with or without text (+ Original or white color)
 *
 * If no logoURLs are passed, we will fallback to the default commutifi logos
 * Also adapts to interactions, if there is an onClick handler we style it to show a pointer cursor with hover effect
 */
export function BrandedLogo({
  logoURLs,
  white = false,
  hideText = false,
  onClick,
  className,
  height
}: {
  /**
   * Customize logos (logo mark or logo with text, color or white).
   * If this isn't passed as a param, we will fallback to the default commutifi logo
   */
  logoURLs?: LogoURLs | null
  white?: boolean
  hideText?: boolean
  onClick?: React.MouseEventHandler
  className?: string
  /**
   * Height in px
   */
  height?: number
}) {
  const handleOnClick: React.MouseEventHandler = (e) => onClick?.(e)

  const logoUrl = logoURLs
    ? white
      ? hideText
        ? logoURLs.smallWhite
        : logoURLs.white
      : hideText
        ? logoURLs.smallColor
        : logoURLs.color
    : null

  const Container = onClick ? 'a' : 'div'

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- Consider refactoring
    <Container
      className={cx('app-branded-logo', className)}
      onClick={handleOnClick}
      // Make sure antd line-height doesn't affect logo height since the height is sometimes set to 100%
      // or set to match the width
      style={{ width: 'fit-content', lineHeight: 1, height: 'auto' }}
    >
      {logoUrl ? (
        <img
          src={logoUrl}
          alt="logo"
          data-testid="commutifi-logo-svg"
          style={{ maxHeight: '40px', maxWidth: '100%' }}
        />
      ) : (
        <CommutifiLogo
          fill={white ? '#ffffff' : colors.primary400}
          key="commutifi-logo"
          hideText={hideText}
          height={height}
        />
      )}
    </Container>
  )
}
